import { render, staticRenderFns } from "./systemuserlist.vue?vue&type=template&id=afb1bfae&scoped=true"
import script from "./systemuserlist.vue?vue&type=script&lang=js"
export * from "./systemuserlist.vue?vue&type=script&lang=js"
import style0 from "./systemuserlist.vue?vue&type=style&index=0&id=afb1bfae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb1bfae",
  null
  
)

export default component.exports